import { render } from "./PurgeEmployee.vue?vue&type=template&id=4b5da756"
import script from "./PurgeEmployee.vue?vue&type=script&lang=js"
export * from "./PurgeEmployee.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__